import { z } from 'zod';

export const SeeImageToolName = 'seeImage' as const;
export const seeImageArgsSchema = z.object({
  url: z
    .string()
    .url()
    .describe(
      'Exact image URL from the user, instructions, or tool results. Never invent a URL.',
    ),
});
